import { render, staticRenderFns } from "./headerImage.vue?vue&type=template&id=58af0dfc&scoped=true"
import script from "./headerImage.vue?vue&type=script&lang=js"
export * from "./headerImage.vue?vue&type=script&lang=js"
import style0 from "./headerImage.vue?vue&type=style&index=0&id=58af0dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58af0dfc",
  null
  
)

export default component.exports